import axios from '../http-common';

import { UserType, UserTableType, UserManageType } from '@/types/auth';

export const getUsers = async (): Promise<UserTableType[]> => {
  try {
    const { data } = await axios.get<UserType[]>('/users');
    return data.map(({ id, ...others }) => ({
      key: id,
      ...others
    }));
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const createUser = async ({ key, ...others }: UserManageType): Promise<void> => {
  try {
    await axios.post('/users', { ...others });
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const updateUser = async ({ key, ...others }: UserManageType): Promise<void> => {
  try {
    await axios.put(`/users/${key}`, { ...others });
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const deleteUser = async (id: string): Promise<void> => {
  try {
    await axios.delete(`/users/${id}`);
  } catch (error) {
    throw new Error((error as Error).message);
  }
};
